import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {
    search_text: "",
  },
};

const masterCustomerSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters(state) {
      state.filters = initialState.filters;
    },
  },
});

export const { setFilters, resetFilters } = masterCustomerSlice.actions;
export default masterCustomerSlice.reducer;
